import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "teknikdestek";
var destekService = {
    destekTalebi(mesaj, resim) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                mesaj: mesaj,
                resim: resim,
                methodName: "destek"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    }
}

export default destekService

